import { forwardRef } from 'react';
import './Badge.css';

const Badge = forwardRef(({
  as: Element = 'span',
  variant = 'light-grey',
  iconOnly = false,
  className = '',
  children,
  ...props
}, ref) => (
  <Element
    ref={ref}
    {...(Element === 'button' ? { type: 'button' } : {})}
    className={`rds-badge rds-badge--${variant}${iconOnly ? ' rds-badge--icon-only' : ''} ${className}`.trim()}
    {...props}
  >
    {children}
  </Element>
));

Badge.displayName = 'Badge';

export const BadgeButton = forwardRef(({ className = '', ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={`rds-badge-button ${className}`.trim()}
    {...props}
  />
));

BadgeButton.displayName = 'BadgeButton';

export default Badge;
